import React, { useCallback, useMemo } from 'react';
import { SettingsItem, SettingsSection } from 'design-system';
import IconBoldQuestion from 'design-system/icons/IconBoldQuestion';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectCreditReport } from '../selectors';
import { buildDisputeItems } from '../utils/disputeItems';
const strings = {
    sectionName: 'Actions',
    title: 'Something wrong?',
    description: 'Raise a dispute if you believe there are incorrect details on your report',
};
const DisputeActionCard = ({ params }) => {
    const navigation = useMainStackNavigation();
    const data = useAppSelector(selectCreditReport);
    const { category, accountId, searchReference } = params;
    const hasItems = useMemo(() => buildDisputeItems(data, { category, accountId, searchReference }).length >
        0, [data, category, accountId, searchReference]);
    const onPress = useCallback(() => {
        navigation.navigate('CreditReportDispute', {
            category,
            accountId,
            searchReference,
        });
    }, [navigation, category, accountId, searchReference]);
    if (!hasItems)
        return null;
    return (<SettingsSection name={strings.sectionName}>
      <SettingsItem title={strings.title} description={strings.description} icon={<IconBoldQuestion gradientKey="turquoise"/>} onPress={onPress}/>
    </SettingsSection>);
};
export default React.memo(DisputeActionCard);
